$(document).ready(function () {
  var $slider = $('.custom-slideshow-main');

  $slider.on('init afterChange', function (event, slick, currentSlide) {
    $('.custom-slideshow-image-col').removeClass('active').css('transform', 'scale(1)');

    var $current = $(slick.$slides[currentSlide]).find('.custom-slideshow-image-col');
    var enableZoom = $current.data('enable-zoom');

    if (enableZoom === true || enableZoom === "true") {
      $current.addClass('active').css('transform', 'scale(0.95)');
    }
  });

  $slider.slick({
    dots: true,
    appendDots: $('.custom-slideshow-dots-wrapper'),
    dotsClass: 'custom-slideshow-dots',
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    cssEase: 'linear',
  });
});

document.addEventListener("DOMContentLoaded", function(){
  const wrappers = document.querySelectorAll(".image-badge-wrapper");

  wrappers.forEach(wrapper => {
    const texts = wrapper.querySelectorAll(".image-badge-text");
    let index = 0;

    if (texts.length > 1) {
      setInterval(() => {
        texts[index].classList.remove("active");
        index = (index + 1) % texts.length;
        texts[index].classList.add("active");
      }, 5000); // 5 sec
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  function initMultiSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.multi-slider').hasClass('slick-initialized')) {
        $('.multi-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 1000,
          pauseOnHover:false
        });
      }
    } else {
      if ($('.multi-slider').hasClass('slick-initialized')) {
        $('.multi-slider').slick('unslick');
      }
    }
  }

  // Run on load
  initMultiSlider();

  // Run again on window resize
  window.addEventListener('resize', function() {
    initMultiSlider();
  });
});
document.addEventListener("DOMContentLoaded", function() {
  function initMobileSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.image-with-video-slider').hasClass('slick-initialized')) {
        $('.image-with-video-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.image-with-video-slider').hasClass('slick-initialized')) {
        $('.image-with-video-slider').slick('unslick');
      }
    }
  }

  // Run once on load
  initMobileSlider();

  // Run again on window resize
  window.addEventListener('resize', function() {
    initMobileSlider();
  });
});
